(() => {
  class BaseDialogElement extends HTMLElement {
    connectedCallback() {
      this.opener = this.querySelector(".js-dialog-opener");
      this.closer = this.querySelector(".js-dialog-closer");
      this.dialog = this.querySelector(".js-dialog");
      this.handleEscape = this.handleEscape.bind(this);

      if (!this.opener || !this.closer || !this.dialog) {
        throw new Error("Missing required elements");
      }

      this.dialog.setAttribute("aria-modal", "true");

      this.opener.addEventListener("click", () => {
        this.openModal();
      });

      this.closer.addEventListener("click", () => {
        this.closeModal();
      });

      this.dialog.addEventListener("click", (e) => {
        this.checkClickOutside(e);
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          this.closeModal();
        }
      });
    }

    disconnectedCallback() {
      document.removeEventListener("keydown", this.handleEscape);
    }

    handleEscape(event) {
      if (event.key === "Escape") {
        this.closeModal();
      }
    }

    openModal() {
      this.dialog.showModal();
      document.body.classList.add("remove-scrolling");
      document.addEventListener("keydown", this.handleEscape);
    }

    closeModal() {
      this.dialog.close();
      document.body.classList.remove("remove-scrolling");
      document.removeEventListener("keydown", this.handleEscape);
    }

    checkClickOutside(e) {
      const dialogDimensions = this.dialog.getBoundingClientRect();
      if (
        e.clientX < dialogDimensions.left ||
        e.clientX > dialogDimensions.right ||
        e.clientY < dialogDimensions.top ||
        e.clientY > dialogDimensions.bottom
      ) {
        this.closeModal();
      }
    }
  }

  if (!customElements.get("base-dialog")) {
    customElements.define("base-dialog", BaseDialogElement);
  }
})();
